import { render, staticRenderFns } from "./ModalElement.vue?vue&type=template&id=8485f782&scoped=true"
import script from "./ModalElement.vue?vue&type=script&lang=js"
export * from "./ModalElement.vue?vue&type=script&lang=js"
import style0 from "./ModalElement.vue?vue&type=style&index=0&id=8485f782&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8485f782",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8485f782')) {
      api.createRecord('8485f782', component.options)
    } else {
      api.reload('8485f782', component.options)
    }
    module.hot.accept("./ModalElement.vue?vue&type=template&id=8485f782&scoped=true", function () {
      api.rerender('8485f782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalElement.vue"
export default component.exports